import { inject, Injectable } from '@angular/core';
import { EeaEndpointsParametersPwcLogicService } from "../../eea-endpoints/eea-endpoints-parameters-pwc/eea-endpoints-parameters-pwc.logic.service";
import { EndpointGet } from "src/app/shared/models/endpoint";
import { lastValueFrom, Observable, take } from 'rxjs';
import { Constants } from 'src/app/shared/utils/constants';
import { DataSetApiService } from 'src/app/shared/services/echo/data-set.api.service';
@Injectable({
    providedIn: 'root'
})
export class EEAGapSurfaceWaterPWCLogicService {
    private endPointLogicService = inject(EeaEndpointsParametersPwcLogicService)
    private dataSetApiService=inject(DataSetApiService)
    public async getEndpoints(datasetPk: number): Promise<void> {
        if (!datasetPk) return;

        const endpointsDb = await this.endPointLogicService.getEndpoints(datasetPk);

        endpointsDb.forEach(endpointDb => {
            if (endpointDb.endpointFieldValue.toLowerCase() === Constants.DATA_VALUES_NAMES.isKoc.toLowerCase()) {
               this.endPointLogicService.updateIsKd(endpointDb.value === 0 ? true : false);
               
            }
        });
    }
    public async getDatasetPk(projectPk:number): Promise<number> {
        const source$ = this.dataSetApiService.getAllDatasetByProjectPk(projectPk).pipe(take(1));
        const datasets = await lastValueFrom(source$);
        return datasets;
    }
    
}